import { Component, inject, Input, output, input } from '@angular/core';

import { I18nService, TranslatePipe } from '@core/i18n-legacy';
import type { ReferralsPortalApplication } from '@core/referrals-types';
import { ReferralContext, ReferralsPortalApplicationStatus } from '@core/referrals-types';
import { TimeAgoPipe } from '@core/time-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  AvatarComponent,
  BoxComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rtr-referrals-card',
  templateUrl: './referrals-card.component.html',
  styleUrls: ['./referrals-card.component.less'],
  imports: [
    BoxComponent,
    AvatarComponent,
    HeadingComponent,
    IconComponent,
    RtTooltip,
    TimeAgoPipe,
    TranslatePipe,
  ],
})
export class ReferralsCardComponent {
  private readonly i18n = inject(I18nService);
  public readonly ReferralStatus: typeof ReferralsPortalApplicationStatus =
    ReferralsPortalApplicationStatus;
  public readonly ReferralContext: typeof ReferralContext = ReferralContext;

  public readonly showStatus = input<boolean>(undefined!);
  public readonly type = input<ReferralContext>(undefined!);
  public readonly rewardsVisible = input<boolean>(undefined!);
  public readonly statusTranslationsMap = input<
    Record<
      string,
      {
        status: string;
        icon: IconName;
      }
    >
  >(undefined!);
  public referralSelect = output<ReferralsPortalApplication>();

  @Input() public application: ReferralsPortalApplication;
  public offerTooltipTranslations: Record<string, string> = {
    [ReferralsPortalApplicationStatus.InReview]: this.i18n.translate(
      'rtr.job_details.status_tooltip.in_progress',
    ),
    [ReferralsPortalApplicationStatus.ProcessComplete]: this.i18n.translate(
      'rtr.job_details.status_tooltip.completed',
    ),
    [ReferralsPortalApplicationStatus.Claimed]: this.i18n.translate(
      'rtr.job_details.status_tooltip.success',
    ),
  };

  public selectCandidate(application: ReferralsPortalApplication): void {
    if (!this.rewardsVisible() || !this.application.referralReward) return;
    this.referralSelect.emit(application);
  }
}
